import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './UsersManagementPage.css';
import { isObjectsEqual, isArraysEqual } from 'common/utils/helpers';
import { Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import classnames from 'classnames';
import { roleAssign } from 'apis/RolesAndPermissionManager';
import UsersManagementTable from 'components/features/UsersManagementTable/UsersManagementTable';
import Modal from 'components/shared/Modal/Modal';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import SearchBar from 'components/shared/SearchBar/SearchBar';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import {
  setPage,
  updateUsersManagementUsersList,
  updateUsersManagementSearchString,
  updateStatus,
  fetchAndUpdateRoleUsers,
  fetchAndUpdateUsers,
  fetchAndUpdateUsersManagementRoleList
} from 'redux/actions';
import { CheckCard } from 'components/shared/CheckCard/CheckCard';

class UsersManagementPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchString: '',
      createUserModalOpen: false,
      userDetailModalOpen: false,
      applyRolesModalOpen: false,
      selectedRoles: null,
      hasNewChange: false,
      isEditUserDetailClicked: false,
      selectedUserId: null //gets updated from table columns
    };
  }

  componentWillUnmount() {}

  componentDidMount() {
    const {
      filteredUsers: { local, original },
      roleUsers,
      roleList,
      searchString,
      dispatch,
      selectedUsersDictionary
    } = this.props;
    let numOfSelectedUsers = Object.keys(selectedUsersDictionary).length;
    const actionButtonDiv = document.getElementsByClassName('UsersManagementPage_ActionButtonDiv')[0];
    if (actionButtonDiv) actionButtonDiv.style.height = numOfSelectedUsers > 0 ? '24px' : '0px';

    this.setState({ searchString });
    dispatch(setPage('UsersManagementPage'));
    dispatch(fetchAndUpdateRoleUsers());

    if (!local || !original) dispatch(fetchAndUpdateUsers());
    dispatch(fetchAndUpdateUsersManagementRoleList(this));
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      props: {
        filteredUsers,
        filteredUsers: { local, original },
        dispatch,
        selectedUserId,
        roleUsers
      },
      state: { searchString, userDetailModalOpen, selectedRoles, applyRolesModalOpen }
    } = this;

    if (searchString !== prevState.searchString)
      dispatch(updateUsersManagementUsersList(local, original, searchString));

    if (applyRolesModalOpen !== prevState.applyRolesModalOpen) this.clearRolesSelection();

    if (userDetailModalOpen !== prevState.userDetailModalOpen) {
      let userRoles = roleUsers && roleUsers[selectedUserId];
      let newSelectedRoles = JSON.parse(JSON.stringify(selectedRoles));

      for (let key of Object.keys(newSelectedRoles)) {
        newSelectedRoles[key].active = false;
      }

      if (userRoles) {
        for (let role of userRoles) {
          newSelectedRoles[role.role].active = true;
        }
      }

      this.setState({ selectedRoles: newSelectedRoles });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {
      props: {
        filteredUsers,
        roleUsers,
        roleList,
        usersStatus,
        permissions,
        selectedUsersDictionary,
        roleAssignStatus,
        roleUsersStatus
      },
      state: {
        createUserModalOpen,
        userDetailModalOpen,
        applyRolesModalOpen,
        selectedRoles,
        hasNewChange,
        isEditUserDetailClicked
      }
    } = this;

    let stateChange = false;
    let propsChange = false;

    if (
      nextState.createUserModalOpen !== createUserModalOpen ||
      nextState.userDetailModalOpen !== userDetailModalOpen ||
      nextState.applyRolesModalOpen !== applyRolesModalOpen ||
      nextState.isEditUserDetailClicked !== isEditUserDetailClicked ||
      nextState.selectedRoles !== selectedRoles ||
      nextState.hasNewChange !== hasNewChange ||
      nextState.searchString !== this.state.searchString ||
      !isObjectsEqual(nextState.selectedRoles, selectedRoles)
    ) {
      stateChange = true;
    }

    if (
      nextProps.roleUsers !== roleUsers ||
      nextProps.roleList !== roleList ||
      nextProps.searchString !== this.props.searchString ||
      nextProps.usersStatus !== usersStatus ||
      nextProps.roleUsersStatus !== roleUsersStatus ||
      nextProps.roleAssignStatus !== roleAssignStatus ||
      !isArraysEqual(nextProps.permissions, permissions) ||
      !isObjectsEqual(nextProps.selectedUsersDictionary, selectedUsersDictionary) ||
      !isObjectsEqual(nextProps.roleUsers, roleUsers) ||
      !isObjectsEqual(nextProps.roleList, roleList)
    ) {
      propsChange = true;
    }

    return stateChange || propsChange;
  }

  handleSearchString = (searchString) => {
    this.setState({ searchString });
    this.props.dispatch(updateUsersManagementSearchString(searchString));
  };

  handleRolesSelection = (role) => {
    let selectedRoles = JSON.parse(JSON.stringify(this.state.selectedRoles));
    selectedRoles[role.role].active = !selectedRoles[role.role].active;
    this.setState({ selectedRoles, hasNewChange: true });
  };

  clearRolesSelection = () => {
    let selectedRoles = JSON.parse(JSON.stringify(this.state.selectedRoles));
    let keys = Object.keys(selectedRoles);

    for (let key of keys) {
      selectedRoles[key].active = false;
    }

    this.setState({ selectedRoles });
  };

  handleApplyRoleAssign = async (userIds) => {
    const {
      state: { selectedRoles },
      props: { dispatch }
    } = this;
    let roleIds = [];
    let statusName = 'POST-RoleAssign';
    let allSuccess = true;

    for (let role of Object.keys(selectedRoles)) {
      if (selectedRoles[role].active) {
        // console.log(role);
        roleIds.push(selectedRoles[role].id);
      }
    }

    // console.log("userIds", userIds);
    // console.log("roleIds", roleIds);

    dispatch(updateStatus(statusName, Status.PENDING));

    for (let userId of userIds) {
      await roleAssign(userId, roleIds)
        .then((result) => {
          if (result && result.status !== 'OK') allSuccess = false;
          // console.log("result.status", result.status);
        })
        .catch((error) => {
          console.error(error);
          allSuccess = false;
        });
    }

    setTimeout(() => {
      dispatch(updateStatus(statusName, allSuccess ? Status.SUCCESS : Status.FAILURE));

      setTimeout(() => {
        dispatch(updateStatus(statusName, null));
        dispatch(fetchAndUpdateRoleUsers());
        this.closeAllModals();
      }, 1000);
    }, 5000);
  };

  handleCancelRoleAssign = (selectedRoles, existingRoles) => {
    let originalSelectedRoles = JSON.parse(JSON.stringify(selectedRoles));
    for (let role of Object.keys(originalSelectedRoles)) {
      if (existingRoles[role]) {
        originalSelectedRoles[role].active = true;
      } else {
        originalSelectedRoles[role].active = false;
      }
    }

    this.setState({ isEditUserDetailClicked: false, selectedRoles: originalSelectedRoles, hasNewChange: false });
  };

  closeAllModals = () => {
    this.setState({
      createUserModalOpen: false,
      userDetailModalOpen: false,
      applyRolesModalOpen: false,
      hasNewChange: false,
      isEditUserDetailClicked: false
    });
  };

  render() {
    // console.log("rendering users management page");
    const {
      props: {
        filteredUsers,
        usersStatus,
        roleUsersStatus,
        dispatch,
        searchString,
        location,
        selectMode,
        selectedUsersDictionary,
        roleList,
        roleUsers,
        roleAssignStatus,
        permissions
      },
      state: {
        createUserModalOpen,
        userDetailModalOpen,
        applyRolesModalOpen,
        selectedRoles,
        hasNewChange,
        isEditUserDetailClicked,
        selectedUserId
      }
    } = this;

    let parent = this;
    let createUserModal = null;
    let userDetailModal = null;
    let applyRolesModal = null;
    let postRoleAssignStatusName = 'POST-RoleAssign';
    let hasAuthAssignPermission = permissions.includes('auth_assign');
    let hasAuthDeletePermission = permissions.includes('auth_delete');
    let numOfSelectedUsers = Object.keys(selectedUsersDictionary).length;
    let actionButtonDiv = document.getElementsByClassName('UsersManagementPage_ActionButtonDiv')[0];
    let loadingIcon = (
      <svg className="spinner" viewBox="0 0 50 50">
        <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
      </svg>
    );

    if (actionButtonDiv) actionButtonDiv.style.height = numOfSelectedUsers > 0 ? '24px' : '0px';

    if (createUserModalOpen) {
      createUserModal = (
        <Modal
          width={1380}
          height={780}
          noPadding={true}
          colorize={'#f8f9fa'}
          opaque={true}
          global
          close={() => {
            this.clearRolesSelection();
            this.closeAllModals();
          }}
        >
          <div className={classnames({ UsersManagementPage_Modal_Wrapper: true })}>
            <div className="UsersManagementPage_Modal_Container">
              <div className="UsersManagementPage_Modal_Content">
                <div className="UsersManagementPage_Modal_Header">Create a new user</div>
                <div className="UsersManagementPage_CreateUserForm_Container">
                  <form className="UsersManagementPage_CreateUserForm">
                    <div className="UsersManagementPage_InputField">
                      <label className="UsersManagementPage_InputLabel">
                        <span className="UsersManagementPage_LabelText">Name</span>
                        <input className="UsersManagementPage_InputValue" type="text" name="name" />
                      </label>
                      <label className="UsersManagementPage_InputLabel">
                        <span className="UsersManagementPage_LabelText">Email</span>
                        <input className="UsersManagementPage_InputValue" type="email" name="email" />
                      </label>
                    </div>
                    <div className="UsersManagementPage_AssignRolesField">
                      <label className="UsersManagementPage_InputLabel">
                        <span className="UsersManagementPage_LabelText">Roles</span>
                      </label>
                      <PerfectScrollbar>
                        <div className="UsersManagementPage_Roles_Box">
                          {roleList &&
                            roleList.map((role, index) => {
                              if (role.role === 'auth_admin') return null;
                              let isSelected =
                                selectedRoles && selectedRoles[role.role] && selectedRoles[role.role].active
                                  ? true
                                  : false;
                              return (
                                <CheckCard
                                  key={index}
                                  index={index}
                                  title={role.role}
                                  isSelected={isSelected}
                                  description={role.description}
                                  onClick={() => this.handleRolesSelection(role)}
                                />
                              );
                              // return (
                              //     <div
                              //         className={classnames({"UsersManagementPage_RoleCard": true, "UsersManagementPage_RoleCard_Selected": isSelected})}
                              //         key={idx}
                              //         onClick={() => this.handleRolesSelection(role)}
                              //     >
                              //         <div className="UserManagementPage_RoleName_Header">
                              //             <span className="UserManagementPage_RoleName" title={role.role}>{role.role}</span>
                              //             <SvgAF
                              //                 img={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_none_selected}
                              //                 hover={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_select_hover}
                              //             />
                              //         </div>
                              //         <p className="UserManagementPage_RoleDescription" title={role.description}>{role.description ? role.description : ''}</p>
                              //     </div>
                              // )
                            })}
                        </div>
                      </PerfectScrollbar>
                    </div>
                    <div className="UsersManagementPage_BottomButtonsField">
                      <button
                        className="UserManagementPage_CancelButton"
                        disabled={!hasNewChange}
                        onClick={() => {
                          this.clearRolesSelection();
                          this.setState({ createUserModalOpen: false, hasNewChange: false });
                        }}
                      >
                        Cancel
                      </button>
                      <button className="UserManagementPage_SubmitButton" type="submit" disabled={!hasNewChange}>
                        Apply
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      );
    }

    if (userDetailModalOpen) {
      let submitButton = 'Apply';
      let selectedUserObject = null;
      let name = null;
      let email = null;
      let existingRoles = {};
      let userRoles = roleUsers && roleUsers[selectedUserId];

      if (roleAssignStatus === Status.PENDING) {
        submitButton = loadingIcon;
      } else if (roleAssignStatus === Status.SUCCESS) {
        submitButton = 'Applied';
      } else if (roleAssignStatus === Status.FAILURE) {
        submitButton = 'Failed';
      }

      if (filteredUsers && filteredUsers.local && selectedUserId) {
        selectedUserObject = filteredUsers.local.find((user) => user.user_id === selectedUserId);
        name = selectedUserObject?.name;
        email = selectedUserObject?.email;
      }

      if (userRoles) {
        for (let roleObj of userRoles) {
          existingRoles[roleObj.role] = true;
        }
      }

      userDetailModal = (
        <Modal
          width={1380}
          height={isEditUserDetailClicked ? 780 : 700}
          noPadding={true}
          colorize={'#f8f9fa'}
          opaque={true}
          global
          close={() => {
            this.closeAllModals();
            this.clearRolesSelection();
          }}
        >
          <div
            className={classnames({
              UsersManagementPage_Modal_Wrapper: true,
              UsersManagementPage_DisabledButton: roleAssignStatus === Status.PENDING
            })}
          >
            <div className="UsersManagementPage_Modal_Container">
              <div className="UsersManagementPage_Modal_Content">
                <div className="UsersManagementPage_Modal_Header">
                  <span className="UsersManagementPage_Modal_HeaderText">
                    {isEditUserDetailClicked ? 'Edit details' : 'User details'}
                  </span>
                  {!isEditUserDetailClicked && hasAuthAssignPermission ? (
                    <div
                      className="UsersManagementPage_EditButton"
                      onClick={() => {
                        let selectedRoles = JSON.parse(JSON.stringify(this.state.selectedRoles));
                        for (let role of Object.keys(existingRoles)) {
                          if (existingRoles[role]) {
                            selectedRoles[role].active = true;
                          }
                        }
                        this.setState({ isEditUserDetailClicked: !isEditUserDetailClicked, selectedRoles });
                        dispatch(updateStatus(postRoleAssignStatusName, null));
                      }}
                    >
                      <SvgAF img={IconLoader.icon_edit_detail} hover={IconLoader.icon_edit_detail_hover} />
                    </div>
                  ) : null}
                </div>
                <div className="UsersManagementPage_UserDetailForm_Container">
                  <form className="UsersManagementPage_UserDetailForm">
                    <div className="UsersManagementPage_InputField">
                      <label className="UsersManagementPage_InputLabel">
                        <span className="UsersManagementPage_LabelText">Name</span>
                        {isEditUserDetailClicked ? (
                          <input
                            className="UsersManagementPage_InputValue"
                            type="text"
                            name="name"
                            value={name}
                            disabled={true}
                          />
                        ) : (
                          <span className="UsersManagementPage_UserValue">{name}</span>
                        )}
                      </label>
                      <label className="UsersManagementPage_InputLabel">
                        <span className="UsersManagementPage_LabelText">Email</span>
                        {isEditUserDetailClicked ? (
                          <input
                            className="UsersManagementPage_InputValue"
                            type="email"
                            name="email"
                            value={email}
                            disabled={true}
                          />
                        ) : (
                          <span className="UsersManagementPage_UserValue">{email}</span>
                        )}
                      </label>
                    </div>
                    <div className="UsersManagementPage_AssignRolesField">
                      <label className="UsersManagementPage_InputLabel">
                        <span className="UsersManagementPage_LabelText">Roles</span>
                      </label>
                      <PerfectScrollbar>
                        <div
                          className={classnames({
                            UsersManagementPage_Roles_Box: true,
                            UsersManagementPage_DisabledButton: !isEditUserDetailClicked
                          })}
                        >
                          {roleList &&
                            roleList.map((role, idx) => {
                              if (role.role === 'auth_admin') return null;
                              let isSelected =
                                selectedRoles && selectedRoles[role.role] && selectedRoles[role.role].active
                                  ? true
                                  : false;
                              return (
                                <CheckCard
                                  key={idx}
                                  index={idx}
                                  title={role.role}
                                  isSelected={isSelected}
                                  description={role.description}
                                  onClick={() => this.handleRolesSelection(role)}
                                  checkMode={isEditUserDetailClicked}
                                />
                              );
                              // return (
                              //     <div
                              //         className={classnames({"UsersManagementPage_RoleCard": true, "UsersManagementPage_RoleCard_Selected": isSelected})}
                              //         key={idx}
                              //         onClick={() => this.handleRolesSelection(role)}
                              //     >
                              //         <div className="UserManagementPage_RoleName_Header">
                              //             <span className="UserManagementPage_RoleName" title={role.role}>{role.role}</span>
                              //             {
                              //                 isEditUserDetailClicked &&
                              //                 <SvgAF
                              //                     img={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_none_selected}
                              //                     hover={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_select_hover}
                              //                 />
                              //             }
                              //         </div>
                              //         <p className="UserManagementPage_RoleDescription" title={role.description}>{role.description ? role.description : ''}</p>
                              //     </div>
                              // )
                            })}
                        </div>
                      </PerfectScrollbar>
                    </div>
                    {isEditUserDetailClicked ? (
                      <div className="UsersManagementPage_BottomButtonsField">
                        <button
                          className="UserManagementPage_CancelButton"
                          onClick={() => {
                            this.handleCancelRoleAssign(selectedRoles, existingRoles);
                            dispatch(updateStatus(postRoleAssignStatusName, null));
                          }}
                          disabled={!hasNewChange}
                        >
                          Cancel
                        </button>
                        <button
                          className="UserManagementPage_SubmitButton"
                          type="submit"
                          value="Apply"
                          disabled={!hasNewChange}
                          onClick={(e) => {
                            e.preventDefault();
                            this.handleApplyRoleAssign([selectedUserId]);
                          }}
                        >
                          {submitButton}
                        </button>
                      </div>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      );
    }

    if (applyRolesModalOpen) {
      let submitButton = 'Save';
      let selectedUsers = [];

      if (roleAssignStatus === Status.PENDING) {
        submitButton = loadingIcon;
      } else if (roleAssignStatus === Status.SUCCESS) {
        submitButton = 'Saved';
      } else if (roleAssignStatus === Status.FAILURE) {
        submitButton = 'Failed';
      }

      filteredUsers &&
        filteredUsers.local &&
        filteredUsers.local.forEach((user) => {
          if (selectedUsersDictionary[user.user_id]) {
            selectedUsers.push(user);
          }
        });

      applyRolesModal = (
        <Modal
          width={1380}
          height={793}
          noPadding={true}
          overflowY={true}
          colorize={'#f8f9fa'}
          opaque={true}
          global
          close={() => {
            this.clearRolesSelection();
            this.closeAllModals();
          }}
        >
          <div
            className={classnames({
              UsersManagementPage_Modal_Wrapper: true,
              UsersManagementPage_DisabledButton: roleAssignStatus === Status.PENDING
            })}
          >
            <div className="UsersManagementPage_Modal_Container">
              <div className="UsersManagementPage_Modal_Content">
                <div className="UsersManagementPage_Modal_Header">Select roles to apply</div>
                <div className="UsersManagementPage_ApplyRolesForm_Container">
                  <form className="UsersManagementPage_ApplyRolesForm">
                    <div className="UsersManagementPage_InputField">
                      <label className="UsersManagementPage_SelectedUsersLabel">
                        <span className="UsersManagementPage_LabelText">Selected users</span>
                        <div className={classnames({ UsersManagementPage_SelectedUsersChipsWrapper: true })}>
                          {selectedUsers &&
                            selectedUsers.map((user, idx) => {
                              return (
                                <div className="UsersManagementPage_UserChip" key={idx} data-tip={user.name}>
                                  {user.name}
                                </div>
                              );
                            })}
                        </div>
                      </label>
                    </div>
                    <div className="UsersManagementPage_AssignRolesField">
                      <label className="UsersManagementPage_InputLabel">
                        <span className="UsersManagementPage_LabelText">Roles</span>
                      </label>
                      <PerfectScrollbar>
                        <div className="UsersManagementPage_Roles_Box">
                          {roleList &&
                            roleList.map((role, idx) => {
                              if (role.role === 'auth_admin') return null;
                              let isSelected =
                                selectedRoles && selectedRoles[role.role] && selectedRoles[role.role].active
                                  ? true
                                  : false;
                              return (
                                <CheckCard
                                  key={idx}
                                  index={idx}
                                  title={role.role}
                                  isSelected={isSelected}
                                  description={role.description}
                                  onClick={() => this.handleRolesSelection(role)}
                                  checkMode={true}
                                />
                              );
                              // return (
                              //     <div
                              //         className={classnames({"UsersManagementPage_RoleCard": true, "UsersManagementPage_RoleCard_Selected": isSelected})}
                              //         key={idx}
                              //         onClick={() => this.handleRolesSelection(role)}
                              //     >
                              //         <div className="UserManagementPage_RoleName_Header">
                              //             <span className="UserManagementPage_RoleName" title={role.role}>{role.role}</span>
                              //             <SvgAF
                              //                 img={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_none_selected}
                              //                 hover={isSelected ? IconLoader.icon_role_selected : IconLoader.icon_role_select_hover}
                              //             />
                              //         </div>
                              //         <p className="UserManagementPage_RoleDescription" title={role.description}>{role.description ? role.description : ''}</p>
                              //     </div>
                              // )
                            })}
                        </div>
                      </PerfectScrollbar>
                    </div>
                    <div className="UsersManagementPage_BottomButtonsField">
                      <button
                        className="UserManagementPage_CancelButton"
                        disabled={!hasNewChange}
                        onClick={() => {
                          this.clearRolesSelection();
                          this.setState({ applyRolesModalOpen: false });
                          dispatch(updateStatus(postRoleAssignStatusName, null));
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="UserManagementPage_SubmitButton"
                        type="submit"
                        value="Save"
                        disabled={!hasNewChange}
                        onClick={(e) => {
                          e.preventDefault();
                          let userIds = Object.keys(selectedUsersDictionary);
                          this.handleApplyRoleAssign(userIds);
                        }}
                      >
                        {submitButton}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      );
    }

    return (
      <div className="UsersManagementPage pageStyle" key={location.search.substring(1) + '-UsersManagementPage'}>
        {createUserModal}
        {userDetailModal}
        {applyRolesModal}
        <div className="UsersManagementPage_ReturnToDevices_Div">
          <IconAndText
            img={IconLoader.icons_arrow_goback}
            hoverImg={IconLoader.icons_arrow_goback_hover}
            text={'Return to Admin Page'}
            hidden={false}
            onClick={() => this.props.history.push('/console/admin')}
          />
        </div>
        <div className="UsersManagementPage_HeaderDiv">
          <span className="UsersManagementPage_HeaderDiv_Title">
            Users
            {/* <SvgAF 
                            img={IconLoader.icon_roles_add} 
                            hover={IconLoader.icon_roles_add_hover} 
                            onClick={() => {
                                this.setState({createUserModalOpen: true, hasNewChange: false});
                                this.clearRolesSelection();
                            }}
                        /> */}
          </span>
          <div className="UsersManagementPage_HeaderDiv_ButtonRow">
            <div className="UsersManagementPage_Search_Map_Col">
              <div className={'UsersManagementPage_SearchBar_Div'}>
                <SearchBar
                  customIcon={IconLoader.icon_search_blue}
                  startingValue={searchString !== '' ? searchString : null}
                  defaultText={searchString === '' ? 'Look up an user' : searchString}
                  searchQuery={(inputString) => {
                    this.handleSearchString(inputString);
                  }}
                  handleEnter={(event, searchBar) => {
                    searchBar.props.searchQuery(searchBar.state.value);
                    event.target.blur();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        {hasAuthAssignPermission && (
          <div className={'UsersManagementPage_ActionButtonDiv'}>
            {numOfSelectedUsers > 0 && (
              <button
                className="Global_ThinBlueButton"
                onClick={() => {
                  this.setState({ applyRolesModalOpen: true, hasNewChange: false });
                }}
              >
                Apply new roles to selected users
              </button>
            )}
          </div>
        )}

        <UsersManagementTable
          filteredUsers={filteredUsers}
          usersStatus={usersStatus}
          roleUsersStatus={roleUsersStatus}
          selectMode={selectMode}
          selectedUserId={this.props.selectedUserId}
          dispatch={dispatch}
          parent={parent}
          roleUsers={roleUsers}
          hasAuthAssignPermission={hasAuthAssignPermission}
          hasAuthDeletePermission={hasAuthDeletePermission}
        />
        <div style={{ width: '100%', height: '50px' }} />
      </div>
    );
  }
}

export default withRouter(
  connect((store) => {
    let getUsersStatusName = 'GET-Users';
    let getRoleUsersStatusName = 'GET-Role-Users';
    let postRoleAssignStatusName = 'POST-RoleAssign';

    return {
      filteredUsers: store.ui.usersManagementPage.filteredUsers,
      roleUsers: store.ui.usersManagementPage.roleUsers,
      searchString: store.ui.usersManagementPage.searchString,
      usersStatus: store.statuses[getUsersStatusName],
      roleUsersStatus: store.statuses[getRoleUsersStatusName],
      roleAssignStatus: store.statuses[postRoleAssignStatusName],
      permissions: store.data.rolePermissions.permissions,
      selectMode: store.ui.usersManagementPage.selectMode,
      selectedUsersDictionary: store.ui.usersManagementPage.selectedUsersDictionary,
      roleList: store.ui.usersManagementPage.roleList,
      selectedUserId: store.ui.usersManagementPage.selectedUserId
    };
  })(UsersManagementPage)
);
